import React, {useEffect} from "react";
import {Form, Modal} from "react-bootstrap";
import {useUnfreezeCardMutation} from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

const UnfreezeCardModal = ({showUnfreezeCardModal, onHide, details, tableRef}) => {
    const [
        unfreezeCard, // This is the mutation trigger
        {
            isLoading: isUnfreezing,
            isSuccess: frozenSuccessfully,
        }, // This is the destructured mutation result
    ] = useUnfreezeCardMutation()

    /* Close Modal on Successful Unfreeze */
    useEffect(() => {
        if (frozenSuccessfully) {
            cogoToast.success("Created 'Unfreeze Card' action successfully")
            tableRef.current.refresh()
            onHide()
        }
    }, [frozenSuccessfully]);

    /* Unfreeze Card */
    const onSubmit = e => {
        e.preventDefault();
        e.stopPropagation();

        unfreezeCard({
            userId: details?.userId,
            cardId: details?.id,
            cardName: details?.cardName,
            meta: details,
        })
    }

    return (
        <Modal
            show={showUnfreezeCardModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUnfreezing ? "static" : true}
            keyboard={!isUnfreezing}
        >
            <Form
                noValidate
                onSubmit={onSubmit}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Unfreeze Card
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                    <p>{`Are you sure you want to unfreeze ${details?.cardName}?`}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        disabled={isUnfreezing}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isUnfreezing}
                        className="btn btn-primary btn-elevate px-4 ml-4"
                    >
                        Unfreeze
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default UnfreezeCardModal;
